class AffiliateStatisticsView {
  constructor() {
    const chartRoot = document.querySelector('.affiliates-statistics__chart')

    if (!chartRoot) return

    const parseDate = d3.timeParse('%Y-%m-%d')

    const statData = JSON.parse(chartRoot.dataset.stats).map(entry => {
      return {
        date: parseDate(entry[0]),
        value: entry[1],
      }
    })

    const tooltipText = chartRoot.dataset.tooltipText

    const statsChart = new DashboardChart(
      chartRoot.querySelector('.dashboard__chart-graph'),
      statData,
      {
        color: '#4277ce',
        type: 'signups',
        tooltipText: tooltipText,
        width: 1032,
        height: 300,
      },
    )

    statsChart.render()
  }
}

// ---
// Init
// ---
document.addEventListener('DOMContentLoaded', function () {
  return new AffiliateStatisticsView()
})
